/**
 * Triggers (P28 + P30 strip).
 *
 * V1 has no `trigger` registry entity — webhook/polling-driven tool
 * activation is V2 work. The wireframe TriggerBuilder + DeliveryHealth
 * widgets had no backend; removed. The stub `/api/v1/triggers` endpoint
 * returns an empty list with a `data_source` badge.
 */
import type { JSX } from 'react';
import { Workflow } from 'lucide-react';

import { useTriggers } from '@/api/index.js';
import { DataTable, type DataRow } from '@/components/console/DataTable.js';
import { PageHeader } from '@/components/console/PageHeader.js';
import { SectionCard } from '@/components/console/SectionCard.js';
import { AsyncShell } from '@/components/console/StateBlocks.js';

export default function Triggers(): JSX.Element {
  const triggers = useTriggers();
  const rows = (triggers.data?.items ?? []) as readonly DataRow[];

  return (
    <>
      <PageHeader
        eyebrow="Automate"
        title="Triggers"
        description="Event-driven tool activation with webhook + polling modes. V2 — the trigger entity is not yet a first-class registry record."
      />

      <SectionCard
        icon={Workflow}
        title="Active trigger subscriptions"
        text="Each trigger is scoped to a connected account and routes through verification + policy checks."
      >
        <AsyncShell
          isLoading={triggers.isLoading}
          isError={triggers.isError}
          isEmpty={rows.length === 0}
          error={triggers.error}
          loadingTitle="Loading triggers"
          errorTitle="Triggers API unreachable"
          emptyTitle="No triggers"
          emptyHint={
            <>
              {triggers.data?.detail ??
                'Triggers are not yet a first-class registry entity in this release.'}
            </>
          }
        >
          <DataTable
            columns={['trigger', 'toolkit', 'mode', 'account', 'delivery', 'status']}
            rows={rows}
          />
        </AsyncShell>
      </SectionCard>
    </>
  );
}
